import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function uploadProformaPresupuesto (payload, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getUploadFacturae.data)
      }, 3000)
    })
  } else {
    const req = {
      url: '/api/emisionfacturas/subirproformapresupuesto',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { uploadProformaPresupuesto }
